(function(){
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver;

  function num(v){ var n=parseFloat(v); return Number.isFinite(n)?n:0; }
  function carouselStep(track){
    var card=track.firstElementChild;
    if(!card) return track.clientWidth*.82;
    var style=getComputedStyle(track);
    return card.getBoundingClientRect().width + num(style.columnGap || style.gap);
  }

  function duplicateIngredientSlides(track){
    if(track.dataset.nmCloned || track.getAttribute('data-nm-carousel').indexOf('ingredients-')!==0) return;
    var originals=Array.prototype.slice.call(track.children);
    if(originals.length===0 || originals.length>3){ track.dataset.nmCloned='1'; return; }
    for(var round=0; round<2; round++){
      originals.forEach(function(card){
        var clone=card.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden','true');
        clone.classList.add('nm-carousel-clone');
        track.appendChild(clone);
      });
    }
    track.dataset.nmCloned='1';
  }

  function updateButtons(track){
    var id=track.getAttribute('data-nm-carousel');
    var scope=track.closest('.nm-section') || document;
    var prev=scope.querySelector('[data-nm-prev="'+id+'"]');
    var next=scope.querySelector('[data-nm-next="'+id+'"]');
    var max=Math.max(0,track.scrollWidth-track.clientWidth-2);
    if(prev) prev.disabled=track.scrollLeft<=2;
    if(next) next.disabled=track.scrollLeft>=max;
  }

  function initCarousels(root){
    root.querySelectorAll('[data-nm-carousel]').forEach(function(track){
      duplicateIngredientSlides(track);
      var id=track.getAttribute('data-nm-carousel');
      var scope=track.closest('.nm-section') || document;
      scope.querySelectorAll('[data-nm-prev="'+id+'"],[data-nm-next="'+id+'"]').forEach(function(btn){
        if(btn.dataset.nmBound) return;
        btn.dataset.nmBound='1';
        btn.addEventListener('click',function(){
          var dir=btn.hasAttribute('data-nm-next')?1:-1;
          track.scrollBy({left:dir*carouselStep(track),behavior:reduceMotion?'auto':'smooth'});
        });
      });
      if(!track.dataset.nmScrollBound){
        track.dataset.nmScrollBound='1';
        var raf=0;
        track.addEventListener('scroll',function(){
          if(raf) return;
          raf=requestAnimationFrame(function(){updateButtons(track);raf=0;});
        },{passive:true});
      }
      updateButtons(track);
      setTimeout(function(){updateButtons(track);},120);
    });
  }

  function initDrag(root){
    root.querySelectorAll('[data-nm-carousel]').forEach(function(track){
      if(track.dataset.nmDragBound) return;
      track.dataset.nmDragBound='1';
      var active=false,startX=0,startLeft=0,moved=false;
      track.addEventListener('pointerdown',function(e){
        if(e.pointerType==='touch' || e.target.closest('input,button,a,video')) return;
        active=true;moved=false;startX=e.clientX;startLeft=track.scrollLeft;
        track.classList.add('is-dragging');
        try{track.setPointerCapture(e.pointerId);}catch(err){}
      });
      track.addEventListener('pointermove',function(e){
        if(!active) return;
        var dx=e.clientX-startX;
        if(Math.abs(dx)>3)moved=true;
        track.scrollLeft=startLeft-dx;
      });
      function end(e){
        if(!active)return;
        active=false;track.classList.remove('is-dragging');
        try{track.releasePointerCapture(e.pointerId);}catch(err){}
        requestAnimationFrame(function(){updateButtons(track);});
      }
      track.addEventListener('pointerup',end);
      track.addEventListener('pointercancel',end);
      track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
    });
  }

  function initBeforeAfter(root){
    root.querySelectorAll('[data-nm-before-after]').forEach(function(frame){
      var range=frame.querySelector('input[type="range"]');
      if(!range || range.dataset.nmBound) return;
      range.dataset.nmBound='1';
      function sync(){frame.style.setProperty('--nm-pos',range.value+'%');}
      range.addEventListener('input',sync); range.addEventListener('change',sync); sync();
    });
  }

  function initFolds(root){
    root.querySelectorAll('[data-nm-fold]').forEach(function(fold){
      var button=fold.querySelector('.nm-fold__summary');
      if(!button || button.dataset.nmBound) return;
      button.dataset.nmBound='1';
      function set(open){fold.dataset.open=open?'true':'false';button.setAttribute('aria-expanded',open?'true':'false');}
      set(fold.dataset.open!=='false');
      button.addEventListener('click',function(){set(fold.dataset.open!=='true');});
    });
  }

  function initFaq(root){
    root.querySelectorAll('.nm-faq__item').forEach(function(details){
      var summary=details.querySelector('summary'), answer=details.querySelector('.nm-faq__answer');
      if(!summary || !answer || details.dataset.nmFaqBound) return;
      details.dataset.nmFaqBound='1';
      var anim=null;
      summary.addEventListener('click',function(e){
        if(reduceMotion) return;
        e.preventDefault();
        if(anim) anim.cancel();
        var opening=!details.open;
        var start=details.offsetHeight;
        if(opening) details.open=true;
        var end=opening ? summary.offsetHeight+answer.offsetHeight : summary.offsetHeight;
        details.style.overflow='hidden';
        anim=details.animate({height:[start+'px',end+'px'],opacity:[opening?.985:1,opening?1:.985]}, {duration:opening?320:270,easing:'cubic-bezier(.22,.76,.22,1)'});
        anim.onfinish=function(){details.open=opening;details.style.height='';details.style.overflow='';anim=null;};
        anim.oncancel=function(){details.style.height='';details.style.overflow='';anim=null;};
      });
    });
  }

  function animateStats(section){
    if(reduceMotion || section.dataset.nmStatsDone) return;
    section.dataset.nmStatsDone='1';
    section.querySelectorAll('.nm-stat__value').forEach(function(el,i){
      var raw=el.textContent.trim();
      var match=raw.match(/^([0-9]+(?:\.[0-9]+)?)(.*)$/);
      if(!match) return;
      var target=parseFloat(match[1]), suffix=match[2], start=performance.now()+i*80, dur=620;
      function tick(now){
        if(now<start){requestAnimationFrame(tick);return;}
        var p=Math.min(1,(now-start)/dur), eased=1-Math.pow(1-p,3);
        var val=Math.round(target*eased);
        el.textContent=val+suffix;
        if(p<1)requestAnimationFrame(tick); else el.textContent=raw;
      }
      el.textContent='0'+suffix; requestAnimationFrame(tick);
    });
  }

  function getRevealObserver(){
    if(revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver=new IntersectionObserver(function(entries,observer){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        if(entry.target.classList.contains('nm-consumer')) animateStats(entry.target);
        observer.unobserve(entry.target);
      });
    },{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    return revealObserver;
  }

  function initReveals(root){
    var observer=getRevealObserver();
    root.querySelectorAll('.nm-section').forEach(function(section){
      section.setAttribute('data-nm-reveal','');
      if(reduceMotion || !observer){section.classList.add('is-inview');return;}
      if(!section.classList.contains('is-inview')) observer.observe(section);
    });
  }

  function init(root){initCarousels(root);initDrag(root);initBeforeAfter(root);initFolds(root);initFaq(root);initReveals(root);}
  document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  window.addEventListener('resize',function(){document.querySelectorAll('[data-nm-carousel]').forEach(updateButtons);},{passive:true});
})();
